module.exports = __webpack_public_path__ + "371716147f5675f03990c00963aa2d9f.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/788.png
// module id = 1699
// module chunks = 2